var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("max-height: " + _vm.height + "; max-width: " + _vm.width + ";"))},[_c('qrcode-stream',{attrs:{"track":_vm.paintOutline},on:{"decode":_vm.onDecode,"init":_vm.onInit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }